export default "__VITE_ASSET__3a6a49b3__"